interface BundledConfig {
  apiUrl: string;
  cdnUrl: string;
}

export const bundledConfig = BUNDLED_CONFIG as BundledConfig;
